exports = module.exports = require("../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transition[data-v-3583ed58]{-webkit-transition:all .2s ease;transition:all .2s ease}", ""]);

// exports
